import { AxiosPromise } from 'axios';
import client from '../client';

type videoViewIncrementResponse = {
    detail: string
}

type videoViewIncrementprops = {
    videoURL: string
}

export const videoViewIncrement = ( {
    videoURL
}: videoViewIncrementprops ): AxiosPromise<videoViewIncrementResponse> => {
    const params = {
        video_url: videoURL
    }
    return client.patch( `api/video/view/increment`, params )
}


type getVideoViewCountResponse = {
    videoViewCount: number
}
type getVideoViewCountProps = {
    videoURL: string
}

// videoURLは漏れたくないので、postで送る
export const getVideoViewCount = ( { videoURL }: getVideoViewCountProps ): AxiosPromise<getVideoViewCountResponse> =>
    client.post( `api/video/view/`, {
        video_url: videoURL
    } )

